import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['main', 'thumb']

  select(event) {
    const thumb = event.currentTarget
    this.mainTarget.src = thumb.dataset.src

    this.thumbTargets.forEach(t => t.closest('.gallery-thumb').classList.remove('gallery-thumb--active'))
    thumb.closest('.gallery-thumb').classList.add('gallery-thumb--active')
  }
}
